import { HasPermission } from '@shared/components';

import { SubscriptionsHeader, SubscriptionsList } from '../containers';

export const Subscription = () => {
  return (
    <HasPermission permissionFeature="SUBSCRIPTIONS" permissionType="READ" redirect>
      <SubscriptionsHeader />
      <SubscriptionsList />
    </HasPermission>
  );
};
